"use strict";
/**
 * @license
 * Copyright 2019 Xunlei Network.
 *
 * @description
 * Default native api delegate.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeApi = void 0;
var events_1 = require("events");
var sdk_1 = require("@xbase/sdk");
/**
 * 返回not found错误。
 *
 * @return {Promise<T>}
 */
function rejectNoFound() {
    var naError = {
        error: sdk_1.ErrorType.NOT_FOUND,
    };
    return Promise.reject(naError);
}
/**
 * Native Api.
 */
var NativeApi = /** @class */ (function (_super) {
    __extends(NativeApi, _super);
    function NativeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取app info
     * @return {Promise<AppInfo>}
     */
    NativeApi.prototype.getAppInfo = function () {
        return rejectNoFound();
    };
    /**
     * 获取用户信息
     * @return {Promise<SessionUserInfo>}
     */
    NativeApi.prototype.getSessionUserInfo = function () {
        return rejectNoFound();
    };
    /**
     * 传递登录信息给客户端，登录或退出完成后函数才返回
     * @param {LoginInfo} _loginInfo
     * @return {Promise<void>}
     */
    NativeApi.prototype.setLoginInfo = function (_loginInfo) {
        return rejectNoFound();
    };
    /**
     * 展示登录框。
     * @return {Promise<void>}
     */
    NativeApi.prototype.showLoginWindow = function () {
        return rejectNoFound();
    };
    /**
     * 获取access token,access token过期则触发refresh token
     * 会将refresh token等错误返回给web，如
     * error:
     *    -  unauthenticated: has no validate access token
     * @return {Promise<string>}
     */
    NativeApi.prototype.getAccessToken = function () {
        return rejectNoFound();
    };
    /**
     * 传递登录信息给客户端，登录或退出完成后函数才返回。
     *
     * @param {CredentialsLoginInfo} _credentialsLoginInfo
     * @throws {ResponseError} 参数错误则error为invalid_argument。
     * credentialsLoginInfo.credentials不为null，若端已登录则error为already_exists。
     * @return {Promise<void>}
     */
    NativeApi.prototype.setCredentialsLoginInfo = function (_credentialsLoginInfo) {
        return rejectNoFound();
    };
    return NativeApi;
}(events_1.EventEmitter));
exports.NativeApi = NativeApi;
//# sourceMappingURL=interface.js.map